// /utils/extractPublicToc.js

/**
 * Build a TOC label from published heading HTML. We skip injected numbering and
 * `.lexical-emoji` wrappers so order (emoji before/after title) does not matter.
 * Using `span:last-child` alone breaks when the last span is only an emoji image.
 */
function getHeadingTocText(h) {
  const numbering =
    h.querySelector(".heading-number")?.textContent?.trim() ?? "";
  const parts = [];
  for (const child of h.children) {
    if (child.tagName !== "SPAN") continue;
    if (child.classList.contains("heading-number")) continue;
    if (child.classList.contains("lexical-emoji")) continue;
    const t = (child.textContent || "").trim();
    if (t) parts.push(t);
  }
  let text = parts.length
    ? parts.join(" ").replace(/\s+/g, " ").trim()
    : (h.textContent || "").replace(/\s+/g, " ").trim();
  if (numbering) {
    const n = numbering.replace(/\s+/g, " ").trim();
    if (text.startsWith(n)) {
      text = text.slice(n.length).trim();
    }
  }
  return text;
}

export function extractPublicToc(htmlString) {
  const dom = new DOMParser().parseFromString(htmlString, "text/html");

  const headers = dom.querySelectorAll(
    "h1.lexical-header1, h2.lexical-header2, h3.lexical-header3, h4.lexical-header4, h5.lexical-header5, h6.lexical-header6"
  );

  const toc = [];

  headers.forEach((h) => {
    const level = parseInt(h.tagName.replace("H", ""), 10);

    const numbering = h.querySelector(".heading-number")?.textContent?.trim() ?? "";
    const text = getHeadingTocText(h);
    if (!text) return;

    toc.push({
      level,
      numbering,
      text,
    });
  });

  return toc;
}
